import React from 'react';
import ChatList from "../../../Components/Projects/ProjectsChat/ChatList";
import ChatActions from "../../../Components/Projects/ProjectsChat/ChatActions";

const ChatItems = ({
                       typeChat,
                       hasCommonChat,
                       isChatOpen,
                       messages,
                       profileMe,
                       messagesEndRef,
                       handleRightClick,
                       handleClickOutside,
                       menuData,
                       respondMessage,
                       clickReply,
                       chatId,
                       singleProject,
                       handleCloseMenu, hasCompaniesChat,
                       fetchMessages,
                       hasMore,fetchOlderMessages
                   }) => {
    return (
        <>
            {typeChat === 'default' && hasCommonChat && isChatOpen && (
                <div className='projects-chat__list'>
                    <ChatList
                        variant='common'
                        list={messages}
                        profileMeId={profileMe.id}
                        messagesEndRef={messagesEndRef}
                        handleRightClick={handleRightClick}
                        handleClickOutside={handleClickOutside}
                        menuData={menuData}
                        respondMessage={respondMessage}
                        clickReply={clickReply}
                        fetchMessages={fetchMessages}
                        hasMore={hasMore}
                        fetchOlderMessages={fetchOlderMessages}
                    />
                    <ChatActions
                        chatId={chatId}
                        singleProjectId={singleProject.id}
                        fetchMessages={fetchMessages}
                        messagesEndRef={messagesEndRef}
                        respondMessage={respondMessage}
                        handleCloseMenu={handleCloseMenu}
                    />
                </div>
            )}
            {typeChat === 'internal' && hasCompaniesChat && isChatOpen && (
                <div  className='projects-chat__list'>
                    <ChatList
                        variant='companies'
                        list={messages}
                        profileMeId={profileMe.id}
                        singleProjectId={singleProject.id}
                        messagesEndRef={messagesEndRef}
                        handleRightClick={handleRightClick}
                        handleClickOutside={handleClickOutside}
                        menuData={menuData}
                        clickReply={clickReply}
                        hasMore={hasMore}
                        fetchOlderMessages={fetchOlderMessages}
                    />
                    <ChatActions
                        chatId={chatId}
                        singleProjectId={singleProject.id}
                        fetchMessages={fetchMessages}
                        messagesEndRef={messagesEndRef}
                        respondMessage={respondMessage}
                        handleCloseMenu={handleCloseMenu}
                    />
                </div>
            )}
        </>
    );
};

export default ChatItems;